<script setup>

</script>

<template>
    <div class="d-flex flex-column justify-content-center align-items-center vh-100">
        <h1>Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
    </div>
</template>